<div class="bg-blue-2 d-flex al-center sp-between p-4">
  <div>
    <div>
      <span class="text-white fw-extrabold fs-4">Estado</span>
    </div>
    <div>
      <span class="text-white fs-6 fw-regular">Elige el estado al que pasará tu cliente.</span>
    </div>
  </div>
  <div>
    <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
  </div>
</div>
<mat-dialog-content class="p-4 d-flex flex-column content-form">
  <div>
    <div>
      <span class="fs-6 fw-regular">Actualmente {{this.data?.nombre_completo}} esta:</span>
    </div>
    <br>
    <div class="content-state d-flex al-center sp-center" [ngClass]="getColor(data?.cliente_estado)">
      <span class="text-white">{{this.data?.cliente_estado}}</span>
    </div>
    <br>
    <div>
      <span class="fs-6 fw-regular">Cambiar a:</span>
    </div>
    <br>
    <div class="d-flex gap">
      <div class="content-state d-flex al-center sp-center pointer" [ngClass]="state.selected ? ['enabled',state.color]:['disabled',state.color]" *ngFor="let state of states"
      (click)="changeStateClient(state)">
        <span class="text-white">{{state.descripcion}}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="p-4 text-end content-action">
  <hr>
  <mat-dialog-actions align="end">
    <button mat-flat-button class="bg-blue-2" (click)="saveState()">
      <span class="fw-bold fs-5 text-white me-3">Cambiar estado</span>
      <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
    </button>
  </mat-dialog-actions>
</div>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>